<template>
  <div>
    <h2>This website is not for you!<br>
Its more for people with bigger phones.</h2>
  </div>
</template>

<script>
export default {
  name: 'ScreenInfo',
}
</script>

<style lang="scss" scoped>

div {
  position: fixed;
  height: 100%;
  width: 100%;
  background: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h2 {
    width: 75%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ScreenInfo.vue